import GtmAPI from './gtm-api'

export default GtmAPI
